import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  pageView() {
    if (typeof gtag !== 'function') return
    const el = this.element     
    const pageLocation  = el.dataset.pageLocation 
    const pagePath = el.dataset.pagePath
    const pageTitle = el.dataset.pageTitle
    gtag('event', 'page_view', {
      page_location: pageLocation,
      page_path: pagePath,
      page_title: pageTitle
    })
  }

}
